import { EntryGroup } from './entry-group';

export class Tax {
  id: number;
  global_tax_id: number;
  intranet_id: number;
  chart_of_account_id: number;
  amount: number;
  type: string = 'LiabilityTax';
  contact_id: number;
  frequency: string;
  way: string;
  cutoff: number;
  is_auto_pay: boolean;
  is_direct_withdrawal: boolean;
  is_federal: boolean;
  is_before_health_deduction: boolean;
  is_factor: boolean;
  user_field: string;
  entry_groups: Array<EntryGroup> = [];
  type_str: string;
  chart_of_account_name: string;
  outstanding_obligation: number;
  name: string;
  above: number;
  contact_name: string;
  chart_of_account_ledgers_url: string;
}
